(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["avt-product-fitment"] && !Shopify.designMode) return;
  try {
    const avtProductFitmentExactKey = (selection) => {
    const make = String(selection?.make ?? '').trim();
    const model = String(selection?.model ?? '').trim();
    const year = Number(selection?.year);
    if (!make || !model || make.includes('::') || model.includes('::')) return '';
    if (!Number.isInteger(year) || year < 1900 || year > 2200) return '';
    const key = `${make}::${model}::${year}`;
    return Array.isArray(selection?.compatibilityKeys)
      && selection.compatibilityKeys.length <= 128
      && selection.compatibilityKeys.includes(key)
      ? key
      : '';
  };

  const avtProductFitmentKeyKind = (value) => {
    if (
      typeof value !== 'string'
      || !value
      || value.length > 255
      || /[\u0000-\u001F\u007F]/.test(value)
    ) {
      return '';
    }
    const parts = value.split('::');
    if (parts.some((part) => !part)) return '';
    const yearIsValid = (rawYear) => {
      const year = Number(rawYear);
      return Number.isInteger(year) && year >= 1900 && year <= 2200;
    };
    const yearRangeIsValid = (rawRange) => {
      const match = /^(\d{4})-(\d{4})$/.exec(rawRange);
      if (!match) return false;
      const start = Number(match[1]);
      const end = Number(match[2]);
      return yearIsValid(start) && yearIsValid(end) && start < end;
    };
    if (parts[0] === 'model_years') {
      return parts.length === 4 && yearRangeIsValid(parts[3]) ? 'model_range' : '';
    }
    if (parts[0] === 'index_years') {
      const prefix = parts[1];
      const expectedLength = prefix === 'make' ? 4 : 5;
      return (
        ['make', 'model', 'category', 'model_family', 'platform'].includes(prefix)
        && parts.length === expectedLength
        && yearRangeIsValid(parts.at(-1))
      ) ? 'index' : '';
    }
    if (parts[0] === 'make') {
      return (
        parts.length === 2
        || (parts.length === 3 && yearIsValid(parts[2]))
      ) ? 'index' : '';
    }
    if (['model', 'category', 'model_family', 'platform'].includes(parts[0])) {
      return (
        parts.length === 3
        || (parts.length === 4 && yearIsValid(parts[3]))
      ) ? 'index' : '';
    }
    return parts.length === 3 && yearIsValid(parts[2]) ? 'exact' : '';
  };

  const avtProductFitmentCompatibility = (value) => {
    if (!Array.isArray(value) || value.length > 128) return null;
    const normalized = [];
    for (const item of value) {
      if (typeof item !== 'string' || !item || item.length > 255) return null;
      if (normalized.includes(item)) return null;
      normalized.push(item);
    }
    return normalized;
  };

  const avtProductFitmentContract = (discoveryClass, compatibility) => {
    const values = avtProductFitmentCompatibility(compatibility);
    if (!values) return null;
    if (discoveryClass === 'universal') {
      return values.length === 1 && values[0] === 'universal'
        ? { discoveryClass, compatibility: values }
        : null;
    }
    if (discoveryClass === 'category') {
      return values.length === 0
        ? { discoveryClass, compatibility: values }
        : null;
    }
    if (discoveryClass !== 'specific' || values.length === 0 || values.includes('universal')) {
      return null;
    }
    const kinds = values.map(avtProductFitmentKeyKind);
    if (kinds.some((kind) => !kind)) return null;
    return {
      discoveryClass,
      compatibility: values,
      exactCompatibility: values.filter((_, index) => kinds[index] === 'exact'),
      modelRangeCompatibility: values.filter((_, index) => kinds[index] === 'model_range'),
      indexCompatibility: values.filter((_, index) => kinds[index] === 'index')
    };
  };

  const avtProductFitmentState = (contract, selection) => {
    if (!contract) return { state: 'unknown', bikeLabel: '' };
    if (contract.discoveryClass === 'universal') {
      return { state: 'universal', bikeLabel: '' };
    }
    if (contract.discoveryClass === 'category') {
      return { state: 'category', bikeLabel: '' };
    }
    const exactKey = avtProductFitmentExactKey(selection);
    if (!exactKey) return { state: 'needs_bike', bikeLabel: '' };
    const selectionKeys = selection.compatibilityKeys;
    const modelRangeOverlap = contract.modelRangeCompatibility.some(
      (key) => selectionKeys.includes(key)
    );
    const indexOverlap = contract.indexCompatibility.some(
      (key) => selectionKeys.includes(key)
    );
    return {
      state: contract.exactCompatibility.includes(exactKey) || modelRangeOverlap
        ? 'match'
        : indexOverlap
          ? 'unknown'
          : 'no_match',
      bikeLabel: `${selection.year} ${selection.make} ${selection.model}`
    };
  };

  class AvtProductFitment extends HTMLElement {
    connectedCallback() {
      document.addEventListener('avt:fitment-change', this.handleFitmentChange);
      window.addEventListener('storage', this.handleStorage);
      this.render(this.readSelection());
    }

    disconnectedCallback() {
      document.removeEventListener('avt:fitment-change', this.handleFitmentChange);
      window.removeEventListener('storage', this.handleStorage);
    }

    handleFitmentChange = (event) => {
      this.render(event.detail?.selection ?? this.readSelection());
    };

    handleStorage = (event) => {
      if (event.key !== 'avt-fitment-selection') return;
      this.render(this.readSelection());
    };

    readSelection() {
      try {
        return JSON.parse(window.localStorage.getItem('avt-fitment-selection')) || {};
      } catch {
        return {};
      }
    }

    readCompatibility() {
      const data = this.querySelector('[data-avt-product-fitment-compatibility]');
      try {
        return JSON.parse(data?.textContent ?? 'null');
      } catch {
        return null;
      }
    }

    render(selection) {
      const contract = avtProductFitmentContract(
        this.dataset.discoveryClass,
        this.readCompatibility()
      );
      const result = avtProductFitmentState(contract, selection);
      const heading = this.querySelector('[data-avt-product-fitment-heading]');
      const message = this.querySelector('[data-avt-product-fitment-message]');
      const bikeAction = this.querySelector('[data-avt-product-fitment-bike-action]');
      if (
        !(heading instanceof HTMLElement)
        || !(message instanceof HTMLElement)
        || !(bikeAction instanceof HTMLAnchorElement)
      ) {
        return;
      }

      const copy = {
        needs_bike: [this.dataset.copyNeedsHeading, this.dataset.copyNeedsMessage],
        match: [this.dataset.copyMatchHeading, this.dataset.copyMatchMessage],
        no_match: [this.dataset.copyNoMatchHeading, this.dataset.copyNoMatchMessage],
        universal: [this.dataset.copyUniversalHeading, this.dataset.copyUniversalMessage],
        category: [this.dataset.copyCategoryHeading, this.dataset.copyCategoryMessage],
        unknown: [this.dataset.copyUnknownHeading, this.dataset.copyUnknownMessage]
      }[result.state];
      if (!copy?.every((value) => typeof value === 'string' && value)) return;

      this.dataset.state = result.state;
      heading.textContent = copy[0];
      message.textContent = copy[1].replaceAll('__BIKE__', result.bikeLabel);
      bikeAction.hidden = !['needs_bike', 'match', 'no_match'].includes(result.state);
      bikeAction.textContent = result.state === 'needs_bike'
        ? this.dataset.copySaveAction
        : this.dataset.copyChangeAction;
    }
  }

  if (!customElements.get('avt-product-fitment')) {
    customElements.define('avt-product-fitment', AvtProductFitment);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["avt-project-bridge"] && !Shopify.designMode) return;
  try {
    const avtProjectBridgeIdentifier = /^[a-z0-9][a-z0-9._-]{0,119}$/;

  const avtProjectBridgeVariantId = (value) => {
    const id = typeof value === 'string' ? value.trim() : '';
    return /^[1-9][0-9]{0,15}$/.test(id) && Number.isSafeInteger(Number(id))
      ? id
      : '';
  };

  const avtProjectBridgeExactKey = (selection) => {
    const make = String(selection?.make ?? '').trim();
    const model = String(selection?.model ?? '').trim();
    const year = Number(selection?.year);
    if (!make || !model || make.includes('::') || model.includes('::')) return '';
    if (!Number.isInteger(year) || year < 1900 || year > 2200) return '';
    const key = `${make}::${model}::${year}`;
    return Array.isArray(selection?.compatibilityKeys)
      && selection.compatibilityKeys.includes(key)
      ? key
      : '';
  };

  const avtProjectBridgeSameOriginUrl = (
    value,
    origin = window.location.origin
  ) => {
    try {
      const url = new URL(String(value ?? ''), origin);
      return url.origin === origin && !url.username && !url.password ? url : null;
    } catch {
      return null;
    }
  };

  const avtProjectBridgeLaunchUrl = (
    base,
    project,
    bikeKey,
    origin = window.location.origin
  ) => {
    const url = avtProjectBridgeSameOriginUrl(base, origin);
    const intent = Array.isArray(project?.intents) ? project.intents[0] : '';
    if (
      !url
      || !avtProjectBridgeIdentifier.test(String(project?.jobId ?? ''))
      || !Number.isSafeInteger(project?.jobVersion)
      || project.jobVersion < 1
      || !avtProjectBridgeIdentifier.test(String(intent ?? ''))
      || typeof bikeKey !== 'string'
      || bikeKey.split('::').length !== 3
    ) {
      return '';
    }
    url.searchParams.set('job', project.jobId);
    url.searchParams.set('version', String(project.jobVersion));
    url.searchParams.set('intent', intent);
    url.searchParams.set('bike_key', bikeKey);
    url.hash = '';
    return url.href;
  };

  const avtProjectBridgePayload = (payload, variantId, bikeKey) => {
    if (
      !payload
      || payload.schemaVersion !== 1
      || payload.variantId !== variantId
      || payload.bikeKey !== bikeKey
      || typeof payload.hasProject !== 'boolean'
      || !Array.isArray(payload.projects)
      || payload.projects.length > 20
      || (!bikeKey && payload.projects.length > 0)
    ) {
      return null;
    }
    const projects = [];
    for (const project of payload.projects) {
      if (
        !avtProjectBridgeIdentifier.test(String(project?.jobId ?? ''))
        || !Number.isSafeInteger(project?.jobVersion)
        || project.jobVersion < 1
        || typeof project?.title !== 'string'
        || !project.title.trim()
        || project.title.length > 240
        || !Array.isArray(project?.intents)
        || project.intents.length === 0
        || !project.intents.every(
          (intent) => avtProjectBridgeIdentifier.test(String(intent ?? ''))
        )
        || !Array.isArray(project?.roles)
        || project.roles.length === 0
        || project.roles.length > 20
      ) {
        return null;
      }
      const roles = [];
      for (const role of project.roles) {
        if (
          !avtProjectBridgeIdentifier.test(String(role?.roleId ?? ''))
          || typeof role?.roleLabel !== 'string'
          || !role.roleLabel.trim()
          || role.roleLabel.length > 160
          || !avtProjectBridgeIdentifier.test(String(role?.candidateId ?? ''))
          || typeof role?.candidateLabel !== 'string'
          || !role.candidateLabel.trim()
          || role.candidateLabel.length > 240
        ) {
          return null;
        }
        roles.push({
          roleId: role.roleId,
          roleLabel: role.roleLabel.trim(),
          candidateId: role.candidateId,
          candidateLabel: role.candidateLabel.trim()
        });
      }
      projects.push({
        jobId: project.jobId,
        jobVersion: project.jobVersion,
        title: project.title.trim(),
        intents: [...project.intents],
        roles
      });
    }
    if (!payload.hasProject && projects.length > 0) return null;
    return { hasProject: payload.hasProject, projects };
  };

  class AvtProjectBridge extends HTMLElement {
    controller = null;
    requestSequence = 0;

    connectedCallback() {
      document.addEventListener('variant:update', this.handleVariantUpdate);
      document.addEventListener('avt:fitment-change', this.handleFitmentChange);
      window.addEventListener('storage', this.handleFitmentChange);
      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.handleVariantUpdate);
      document.removeEventListener('avt:fitment-change', this.handleFitmentChange);
      window.removeEventListener('storage', this.handleFitmentChange);
      this.controller?.abort();
    }

    handleVariantUpdate = (event) => {
      if (
        String(event.detail?.data?.productId ?? '')
        !== String(this.dataset.productId ?? '')
      ) {
        return;
      }
      this.dataset.variantId = String(event.detail?.resource?.id ?? '');
      this.refresh();
    };

    handleFitmentChange = (event) => {
      if (
        event?.type === 'storage'
        && event.key !== this.dataset.storageKey
      ) {
        return;
      }
      this.refresh();
    };

    savedBikeKey() {
      try {
        const selection = JSON.parse(
          window.localStorage.getItem(this.dataset.storageKey)
        ) || {};
        return avtProjectBridgeExactKey(selection);
      } catch {
        return '';
      }
    }

    reset() {
      this.hidden = true;
      const projects = this.querySelector('[data-avt-project-bridge-projects]');
      const action = this.querySelector('[data-avt-project-bridge-bike-action]');
      if (projects instanceof HTMLElement) {
        projects.replaceChildren();
        projects.hidden = true;
      }
      if (action instanceof HTMLAnchorElement) action.hidden = true;
    }

    async refresh() {
      const sequence = ++this.requestSequence;
      this.controller?.abort();
      this.controller = new AbortController();
      this.reset();

      const variantId = avtProjectBridgeVariantId(this.dataset.variantId);
      const bikeKey = this.savedBikeKey() || null;
      const endpointSetting = String(this.dataset.endpoint ?? '').trim();
      if (!variantId || !endpointSetting) return;
      const endpoint = avtProjectBridgeSameOriginUrl(endpointSetting);
      if (!endpoint) return;
      endpoint.searchParams.set('variant_id', variantId);
      if (bikeKey) endpoint.searchParams.set('bike_key', bikeKey);
      else endpoint.searchParams.delete('bike_key');
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(endpoint.href, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
          signal: this.controller.signal
        });
        if (!response.ok) throw new Error('Project lookup failed.');
        const payload = avtProjectBridgePayload(
          await response.json(),
          variantId,
          bikeKey
        );
        if (!payload || sequence !== this.requestSequence) return;
        this.render(payload, bikeKey);
      } catch (error) {
        if (error?.name !== 'AbortError' && sequence === this.requestSequence) {
          this.reset();
        }
      } finally {
        if (sequence === this.requestSequence) {
          this.removeAttribute('aria-busy');
        }
      }
    }

    render(payload, bikeKey) {
      if (!payload.hasProject) {
        this.reset();
        return;
      }
      const heading = this.querySelector('[data-avt-project-bridge-heading]');
      const message = this.querySelector('[data-avt-project-bridge-message]');
      const projects = this.querySelector('[data-avt-project-bridge-projects]');
      const action = this.querySelector('[data-avt-project-bridge-bike-action]');
      const template = this.querySelector('[data-avt-project-bridge-template]');
      if (
        !(heading instanceof HTMLElement)
        || !(message instanceof HTMLElement)
        || !(projects instanceof HTMLOListElement)
        || !(action instanceof HTMLAnchorElement)
        || !(template instanceof HTMLTemplateElement)
      ) {
        this.reset();
        return;
      }

      projects.replaceChildren();
      projects.hidden = true;
      action.hidden = true;
      if (!bikeKey) {
        heading.textContent = this.dataset.copySaveHeading;
        message.textContent = this.dataset.copySaveMessage;
        action.textContent = this.dataset.copySaveAction;
        action.hidden = false;
        this.hidden = false;
        return;
      }
      if (payload.projects.length === 0) {
        heading.textContent = this.dataset.copyNoMatchHeading;
        message.textContent = this.dataset.copyNoMatchMessage;
        action.textContent = this.dataset.copyChangeAction;
        action.hidden = false;
        this.hidden = false;
        return;
      }

      heading.textContent = this.dataset.copyMatchHeading;
      message.textContent = this.dataset.copyMatchMessage;
      for (const project of payload.projects) {
        const fragment = template.content.cloneNode(true);
        const title = fragment.querySelector('[data-avt-project-bridge-title]');
        const prefix = fragment.querySelector('[data-avt-project-bridge-role-prefix]');
        const roles = fragment.querySelector('[data-avt-project-bridge-roles]');
        const launch = fragment.querySelector('[data-avt-project-bridge-launch]');
        const launchUrl = avtProjectBridgeLaunchUrl(
          this.dataset.workshopUrl,
          project,
          bikeKey
        );
        if (
          !(title instanceof HTMLElement)
          || !(prefix instanceof HTMLElement)
          || !(roles instanceof HTMLElement)
          || !(launch instanceof HTMLAnchorElement)
          || !launchUrl
        ) {
          continue;
        }
        title.textContent = project.title;
        prefix.textContent = `${this.dataset.copyRolePrefix} `;
        roles.textContent = project.roles.map(({ roleLabel }) => roleLabel).join(', ');
        launch.textContent = this.dataset.copyLaunchAction;
        launch.href = launchUrl;
        projects.append(fragment);
      }
      if (projects.childElementCount === 0) {
        this.reset();
        return;
      }
      projects.hidden = false;
      this.hidden = false;
    }
  }

  if (!customElements.get('avt-project-bridge')) {
    customElements.define('avt-project-bridge', AvtProjectBridge);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class PageSizeSelector extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.select?.addEventListener('change', this.handleChange);
      window.addEventListener('pageshow', this.handleHistoryNavigation);
      window.addEventListener('popstate', this.handleHistoryNavigation);
      this.syncFromUrl();
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.handleChange);
      window.removeEventListener('pageshow', this.handleHistoryNavigation);
      window.removeEventListener('popstate', this.handleHistoryNavigation);
    }

    syncFromUrl() {
      if (!(this.select instanceof HTMLSelectElement)) return;
      const requestedPageSize = new URL(window.location.href).searchParams.get('view');
      this.select.value = ['48', '100'].includes(requestedPageSize) ? requestedPageSize : '24';
    }

    handleHistoryNavigation = () => {
      this.syncFromUrl();
    };

    handleChange = (event) => {
      const url = new URL(window.location.href);
      const pageSize = event.currentTarget.value;

      url.searchParams.delete('page');

      if (pageSize === '24') {
        url.searchParams.delete('view');
      } else {
        url.searchParams.set('view', pageSize);
      }

      window.location.assign(url.toString());
    };
  }

  if (!customElements.get('page-size-selector')) {
    customElements.define('page-size-selector', PageSizeSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
